import type { SkuFragmentFragment } from '@generated/graphql'

export const sortSkuVariations = (skuVariants: SkuFragmentFragment[]) => {
  return [...skuVariants]?.sort(
    (a, b) =>
      parseFloat(a.additionalProperty?.[0]?.value?.replace(',', '.')) -
      parseFloat(b.additionalProperty?.[0]?.value?.replace(',', '.'))
  )
}
